import {clsx} from 'clsx'
import type {ClientDiffLine} from '../../types'
import {Cell} from './Cell'
import type {DiffAnchor} from '@github-ui/diffs/types'

/**
 * Renders an empty cell
 */
export function EmptyCell({
  columnIndex,
  diffAnchor,
  diffLine,
  isLeftSide,
  isSplit,
  showRightBorder,
}: {
  columnIndex: number
  diffAnchor: DiffAnchor
  diffLine: ClientDiffLine
  isLeftSide: boolean
  isSplit: boolean
  showRightBorder?: boolean
}) {
  return (
    <Cell
      className={clsx('empty-diff-line', {'border-right': showRightBorder})}
      columnIndex={columnIndex}
      diffAnchor={diffAnchor}
      diffLine={diffLine}
      isLeftSide={isLeftSide}
      isSplit={isSplit}
    />
  )
}
